<script>
	const utilities = require('../../utilities');
	const analyticsUtilities = require('utilities/analyticsUtilities');
	const pubsub = require('events/pubsub');
	const fireEvent = analyticsUtilities.fireEvent;
	const HOMEPAGE_CLICK = analyticsUtilities.events.HOMEPAGE_CLICK;
	const { assetUrl } = require('utilities/urlUtilities');

	const NAV_ITEMS = {
		primaryNavItems: [
			{
				label: 'Content',
				href: '/find-content',
				authenticated: false,
				homepageClick: 'BROWSE_MAIN',
				activeRoutes: ['/article']
			},
			{
				label: 'Content',
				href: '/find-content',
				authenticated: true,
				homepageClick: 'BROWSE_MAIN',
				activeRoutes: ['/article']
			},
			{
				label: 'My Tools',
				href: '/my-tools',
				homepageClick: 'MY_TOOLS',
				authenticated: true
			},
			{
				label: 'Assignments & Progress',
				href: '/assignments',
				activeRoutes: ['/assignment'],
				homepageClick: 'ASSIGNMENTS_PROGRESS',
				authenticated: true
			},
			{
				label: 'Class Admin',
				href: '/class-admin',
				homepageClick: 'CLASS_ADMIN',
				authenticated: true
			}
		],
		secondaryNavItems: [
			{
				label: 'Donate',
				href: '//about.readworks.org/donate.html',
				target: '_blank',
				name: 'MAIN_NAV_DONATE',
				outbound: true,
				teacher: false
			},
			{
				label: 'About',
				href: '//about.readworks.org/',
				target: '_blank',
				name: 'MAIN_NAV_ABOUT',
				outbound: true,
				teacher: false
			},
			{
				label: 'Alignments',
				href: '/teacher-guide/alignments.html',
				target: '_blank',
				name: 'MAIN_NAV_ALIGNMENTS',
				activeRoutes: ['/teacher-guide/alignments.html']
			},
			{
				label: 'Teacher Guide',
				href: '/teacher-guide',
				target: '_self',
				name: 'MAIN_NAV_TEACHING_TIPS'
			},
			{
				label: 'Webinars',
				href: '/webinars',
				target: '_self',
				name: 'MAIN_NAV_WEBINARS'
			},

			{
				label: 'Help',
				href: 'https://help.readworks.org/',
				target: '_blank',
				name: 'MAIN_NAV_HELP',
				outbound: true
			}
		]
	};

	module.exports = {
		components: {
			'nav-link-item': require('components/nav/nav-link-item.vue').default,
			'menu-icon': require('components/svg/menu-icon.vue').default,
			'org-logo': require('components/svg/org-logo.vue').default
		},
		props: ['account-name', 'hide-nav', 'static-logo', 'route-context'],
		modelData: ['userContext'],
		data: function () {
			return {
				mobileMenuOpen: false
			};
		},
		methods: {
			// help: function() {
			// 	if (staticHelp) {
			// 		utilities.openModal('#help');
			// 	}
			// },
			openTeacherLogin: function (url) {
				let opts = {
					url
				};

				this.homepageClickEvent('LOGIN_MAIN');
				this.closeMobileMenu();
				utilities.openModal('#bifurcated-login-modal', opts);
			},
			openMobileMenu: function () {
				this.mobileMenuOpen = true;
			},
			closeMobileMenu(focusTrigger = false) {
				this.mobileMenuOpen = false;
				const mobileTrigger = this.$refs.mobileTrigger;

				if (mobileTrigger && focusTrigger === true) {
					mobileTrigger.focus();
				}
			},
			triggerMobileMenuSubscription() {
				pubsub.publish('mobile-menu-toggled');
			},
			homepageClickEvent(loc, mobile) {
				if (this.routeContext.pathname === '/') {
					fireEvent(HOMEPAGE_CLICK, { loc });
				}
				if (mobile) {
					this.closeMobileMenu();
				}
			}
		},
		computed: {
			primaryNavItems() {
				let activeItem = this.activeItem || {};
				return NAV_ITEMS.primaryNavItems.map(nav => {
					return Object.assign({}, nav, {
						active: activeItem.href === nav.href
					});
				});
			},
			secondaryNavItems() {
				let activeItem = this.activeItem || {};
				return NAV_ITEMS.secondaryNavItems.map(nav => {
					return Object.assign({}, nav, {
						active: activeItem.href === nav.href
					});
				});
			},
			activeItem() {
				let path = this.routeContext.path || '';
				let item = null;
				let matchingRoute = null;

				[...NAV_ITEMS.primaryNavItems, ...NAV_ITEMS.secondaryNavItems].forEach(nav => {
					let activeRoutes = nav.activeRoutes && nav.activeRoutes.length ? nav.activeRoutes : [];
					activeRoutes.unshift(nav.href);
					activeRoutes.forEach(route => {
						if (path.indexOf(route) === 0) {
							if (!matchingRoute || matchingRoute.length < route.length) {
								matchingRoute = route;
								item = nav;
							}
						}
					});
				});

				return item;
			},
			barLoaderSrc() {
				return assetUrl('/assets/dist/images/bar-nav-loader.gif');
			}
		}
	};
</script>
<style lang="scss">
	@import 'mixins/flexbox';
	@import 'config/variables';
	@import 'config/colors';

	.teacher-nav {
		.login-button {
			border: 1px solid $c-white;
			margin-left: 0.5rem;

			&:hover {
				border: 1px solid $c-white;
			}
		}
	}

	@media only screen and (min-width: $bp-width-lg) {
		.teacher-nav {
			.top-nav {
				display: flex;
				align-items: center;
				width: 100%;
				margin-left: 2.625rem;

				.top-nav-list {
					white-space: nowrap;

					&.-primary {
						flex: 1;
					}

					&.-secondary {
						display: inline-block;
					}
				}

				.has-sub-nav {
					position: relative;

					> .link {
						display: flex;
						align-items: center;
					}

					.sub-nav {
						display: none;
					}

					&:hover {
						.sub-nav {
							display: block;
						}
					}
				}
			}

			.account-name {
				display: inline-block;
				max-width: 58px; //value can be adjusted when nav items and spacing change
				margin-right: 3px;
			}
		}
	}
</style>
<template>
	<div class="teacher-nav">
		<a
			v-if="!staticLogo"
			href="/"
			class="top-logo"
			rel="home"
			title="ReadWorks Homepage">
			<org-logo :width="190"></org-logo>
			<img
				:src="barLoaderSrc"
				alt="Loading"
				role="status"
				class="loading-indicator bar-loading-indicator" />
		</a>
		<div
			v-else
			class="top-logo margin-bottom-xs">
			<org-logo :width="190"></org-logo>
			<img
				:src="barLoaderSrc"
				alt="Loading"
				role="status"
				class="loading-indicator bar-loading-indicator" />
		</div>
		<div
			v-show="!hideNav"
			class="top-nav-wrapper">
			<nav class="top-nav">
				<ol class="top-nav-list -primary">
					<template v-for="nav in primaryNavItems">
						<li
							v-if="(userContext && !userContext.classCode && nav.authenticated) || ((!userContext || userContext.classCode) && !nav.authenticated)"
							:class="{
								active: nav.active
							}">
							<a
								v-if="!nav.homepageClick"
								:href="nav.href"
								:data-text="nav.label"
								>{{ nav.label }}</a
							>
							<a
								v-if="nav.homepageClick"
								:href="nav.href"
								:data-text="nav.label"
								@click="homepageClickEvent(nav.homepageClick)"
								>{{ nav.label }}</a
							>
						</li>
					</template>
				</ol>
				<div class="top-auth">
					<ol class="top-nav-list -secondary">
						<template v-for="item in secondaryNavItems">
							<nav-link-item
								v-if="!userContext || item.teacher !== false || (item.teacher === false && userContext.classCode)"
								:class="{
									active: item.active,
									'has-sub-nav': item.navItems && item.navItems.length
								}"
								:item="item">
								<ol
									class="sub-nav"
									v-if="item.navItems">
									<nav-link-item
										v-for="subItem in item.navItems"
										:key="subItem.href"
										:item="subItem"></nav-link-item>
								</ol>
							</nav-link-item>
						</template>
						<li
							v-if="userContext && !userContext.classCode && accountName"
							class="has-sub-nav">
							<div class="link">
								<span class="account-name text-ellipsis">{{ accountName }}</span> <span class="triangle"></span>
							</div>
							<ol class="sub-nav">
								<li v-if="!userContext.organization">
									<a
										href="/my-account"
										@click="homepageClickEvent('MY_ACCOUNT')">
										My Account
									</a>
								</li>
								<li>
									<a href="/logout"> Logout </a>
								</li>
							</ol>
						</li>
					</ol>
					<template v-if="!userContext || userContext.classCode">
						<button
							@click.prevent="openTeacherLogin()"
							class="login-button button -ruled -outline">
							Login
						</button>
					</template>
				</div>
			</nav>
			<button
				class="top-mobile-nav-trigger nav-menu-button"
				ref="mobileTrigger"
				aria-label="Open Navigation Menu"
				:aria-expanded="`${mobileMenuOpen}`"
				aria-controls="mobile-menu"
				@click="openMobileMenu">
				<menu-icon></menu-icon>
			</button>
			<nav
				id="mobile-menu"
				:class="['top-mobile-nav', mobileMenuOpen ? 'open' : '']"
				@transitionend="triggerMobileMenuSubscription">
				<button
					class="button -link mobile-close-icon"
					aria-label="Close Menu"
					@click="closeMobileMenu(true)">
					×
				</button>
				<ol class="mobile-nav-list -primary">
					<li
						v-for="nav in primaryNavItems"
						:key="nav.href"
						v-if="(userContext && !userContext.classCode && nav.authenticated) || ((!userContext || userContext.classCode) && !nav.authenticated)">
						<a
							v-if="!nav.homepageClick"
							:class="{
								active: nav.active
							}"
							@click="closeMobileMenu"
							:href="nav.href"
							>{{ nav.label }}</a
						>
						<a
							v-if="nav.homepageClick"
							:class="{
								active: nav.active
							}"
							:href="nav.href"
							@click="homepageClickEvent(nav.homepageClick, true)"
							>{{ nav.label }}</a
						>
					</li>
				</ol>
				<div class="mobile-nav-list -secondary">
					<ol>
						<template v-for="item in secondaryNavItems">
							<nav-link-item
								v-if="!userContext || item.teacher !== false || (item.teacher === false && userContext.classCode)"
								:item="item"></nav-link-item>
						</template>
					</ol>
					<ol
						v-if="userContext && !userContext.classCode"
						@click="closeMobileMenu">
						<li>
							<a
								href="/my-account"
								@click="homepageClickEvent('MY_ACCOUNT')">
								My Account
							</a>
						</li>
						<li>
							<a href="/logout"> Logout </a>
						</li>
					</ol>
					<ol v-else>
						<li>
							<a
								href="/teacher-signup"
								class="link"
								@click="homepageClickEvent('SIGN_UP_MAIN', true)"
								>Sign Up</a
							>
						</li>
						<li>
							<span
								class="link"
								@click="openTeacherLogin()"
								>Log In</span
							>
						</li>
					</ol>
				</div>
			</nav>
		</div>
	</div>
</template>
